import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  actionTo,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="mt-4 text-base font-medium text-foreground-900">{title}</h3>
      {description && (
        <p className="mt-2 max-w-md text-sm text-foreground-500">{description}</p>
      )}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
      {actionLabel && !actionTo && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}